// @ts-nocheck

/** @type {number?} */
let timerId = null;

/**
 * Приоритет текущего уведомления
 * @type {number}
 */
let currentPriority = 0;

/**
 * Показать всплывающее уведомление
 * @param {string} text Сообщение
 * @param {number} delay Время показа уведомления
 * @param {number} [priority=0] Уведомления с меньшим приоритетом не могут перекрыть уведомления с большим
 */
export function showPopup(text, delay, priority = 0) {
    try {
        if (timerId !== null) {
            if (priority < currentPriority) {
                return;
            }
            clearTimeout(timerId);
        }
        currentPriority = priority;

        const popup =
            /** @type {HTMLElement} */ document.querySelector(".js-popup");
        popup.classList.add("js-popup-visible");

        const popupText =
            /** @type {HTMLElement} */ popup.querySelector(".js-popup__text");
        popupText.innerText = text;

        timerId = setTimeout(function () {
            popup.classList.remove("js-popup-visible");
            timerId = null;
        }, delay);
    } catch (error) {
        console.log(error);
    }
}
